export default {
	methods: {
		isAuthenticated() {
			return !!this.$page.props?.auth?.user;
		},
		hasRole(role) {
			return this.isAuthenticated() && this.$page.props.auth.user.roles.some(function (userRole) {
				return userRole.name === role;
			});
		},
		isSameUser(user) {
			if (!this.isAuthenticated()) {
				return false;
			}

			let authUserId = this.$page.props.auth.user.id;
			let targetId = typeof user === 'object' ? user.id : user;

			return authUserId === targetId;
		},
		canEdit(user, role) {
			return this.isSameUser(user) || this.hasRole(role);
		}
	}
}